import React, { useEffect, useState } from "react"
import { useToasts } from "react-toast-notifications"
import { addProductToRegistry, getCategoryById } from "../../utils/ApiRequests"
import { getApiErrorMessage } from "../../utils/ApiUtils"
import FullLoader from "../Loaders/FullLoader"
import RegistryItemPreview from "../RegistryItemPreview/RegistryItemPreview"

const DisplayCategory = ({ closeModal, categoryId, registryId }) => {
  const [loading, setLoading] = useState(true)
  const [category, setCategory] = useState([])
  const { addToast } = useToasts()
  const [selectedProducts, setSelectedProducts] = useState([])

  const currentRegistry = registryId?.length ? registryId[0] : ""
  useEffect(() => {
    getCategoryById(categoryId)
      .then(res => {
        setCategory(res.data.data)
        setLoading(false)
      })
      .catch(err => {
        addToast(getApiErrorMessage(err.response), {
          appearance: "error",
          autoDismiss: true
        })
      })
    setLoading(false)
  }, [categoryId, addToast])

  const addItems = () => {
    // e.preventDefault()
    setLoading(true)
    addProductToRegistry(currentRegistry, selectedProducts)
      .then(res => {
        setLoading(false)
        addToast(res.data?.message, {
          appearance: "success",
          autoDismiss: true
        })
        closeModal()
        // setShowModal(true)
      })
      .catch(err => {
        setLoading(false)
        addToast(getApiErrorMessage(err.response), {
          appearance: "error",
          autoDismiss: true
        })
      })
  }

  const { name, products } = category || {}

  return (
    <div className="w-11/12 h-90vh bg-white px-5 pt-3 pb-2 medium:w-screen medium:h-90vh">
      {loading && <FullLoader />}
      <button
        className="mb-6 ml-auto block bg-white shadow-lg p-3 text-center text-red-400 rounded-md focus:outline-none"
        onClick={() => closeModal()}
      >
        <img src={require("../../assets/close.svg").default} alt="close" />
      </button>

      <h3 className="text-center text-xl text-gray-600 font-semibold">
        {name}
      </h3>

      <div className="grid grid-flow-row-dense w-full grid-cols-item gap-10 justify-between overflow-y-auto h-3/4 overflow-x-hidden mt-2">
        {products?.map(product => (
          <RegistryItemPreview
            img={product?.images[0]}
            key={product?._id}
            name={product.name}
            addToItems={setSelectedProducts}
            items={selectedProducts}
            id={product._id}
          />
        ))}
      </div>

      <button
        className="mt-5 mx-auto block bg-sbg-light-green px-10 py-3 text-center text-white rounded-md focus:outline-none"
        type="submit"
        onClick={() => addItems()}
      >
        Add Items
      </button>
    </div>
  )
}

export default DisplayCategory
